export default __webpack_public_path__ + "static/Clubhouse-8283468ab0b5b7341a9ed7bb8bfe9e1d.png";